import { useEffect, useState } from 'react';

const useDebounce = <T>(value: T, delay?: number): T => {
	// State and setters for debounced value
	const [debouncedValue, setDebouncedValue] = useState<T>(value);

	useEffect(
		() => {
			// Update debounced value after delay
			const handler = setTimeout(
				() => {
					setDebouncedValue(value);
				},
				delay ? delay : 400,
			); // Productivity soars when a computer and its users interact at a pace (<400ms) that ensures that neither has to wait on the other.

			// Cancel the timeout if value changes (also on delay change or unmount)
			// This is how we prevent debounced value from updating if value is changed ...
			// .. within the delay period. Timeout gets cleared and restarted.
			return () => {
				clearTimeout(handler);
			};
		},
		[value, delay], // Only re-call effect if value or delay changes
	);

	return debouncedValue;
};

export default useDebounce;
